module.exports = __webpack_public_path__ + "static/media/target-logo.7f155d53.png";